<aside>
  <div class="content__container">
    <app-shared-logo [width]="262" class="logo"/>
    <router-outlet />
    <div class="help-button__container">
      <a mat-button target="_blank" href="https://bclonsite.atlassian.net/servicedesk/customer/user/login?destination=portals">
        <div>
          <ogs-m3-icon prefix="fal" icon="question-circle" />
          <p class="mat-label-large">{{"Benötigen Sie Hilfe?" | translate : "action-need-help" : "global"}}</p>
        </div>
      </a>
    </div>
  </div>
		<app-language-select/>
  <footer>
    <a class="mat-body-medium" href="https://bcl-baulogistik.com" target="_blank">bcl-baulogistik.com</a>
    <!-- <ogs-m3-icon prefix="fal" icon="moon" /> -->
    <div class="link__container">
      <a class="mat-body-medium" href="https://bcl-baulogistik.com/impressum/" target="_blank">{{"Impressum" | translate : "action-imprint" : "feature/auth"}}</a>
      <a class="mat-body-medium" href="https://implenia.com/informationen/datenschutz/" target="_blank">{{"Datenschutz" | translate : "action-privacy-policy" : "feature/auth"}}</a>
    </div>
  </footer>
</aside>
<app-authenticate-ui-diashow />
